import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import {
	updateCourseDetails,
	fetchInstruction,
	setShowGrade,
	setPreviewMode,
} from '../../redux/myCourse/myCourse.actions';
import { setGetUserInfo } from '../../redux/profile/profile.actions';
import { changeActiveCourse } from '../../redux/changeCourse/changeCourse.actions';
import Status from './status';
import Detail from './courseDetail/details.container';
import Notification from '../notifications';
import TestInstruction from '../common/testInstruction';
import PermitMicModal from '../common/permitMic';
import ReviewAttemptModal from '../common/reviewAttemptModal';
import { Link } from 'react-router-dom';
import GetGrade from '../common/getGrade';
import { appendScript } from '../../utils/appendScript';
import EchoTest from '../common/EchoTest';
import { getParameterByName } from '../../utils/commonFunctions';
import DefaultLayoutHOC from '../layoutHOC/defaultLayout';
import ListAnimation from '../utils/animations/list';
import Card from 'react-bootstrap/Card';
import Config from '../../config/Config';
import { NavLink } from 'react-router-dom';
import ShimmerEffect from './shimmer';

const MyCourse = ({
	setShowGrade,
	updateCourseDetails,
	changeActiveCourse,
	title,
	getGrade,
	newUser,
	isOlympiad,
	category,
	setGetUserInfo,
	setPreviewMode,
	previewMode,
	product_id,
	coachDetails: { completed_calls, role_name },
	coachDetails,
	course_id,
	isEmailUpdate,
	onlineClassStatus,
	coachCallsStatus,
	liveClassStatus,
	addedGrants,
	paramCourseId,
	coursedetails,
}) => {
	useEffect(() => {
		if (getParameterByName('previewMode') === '1') {
			setPreviewMode(true);
		}
	}, [setPreviewMode]);

	useEffect(() => {
		const setActiveCourse = async () => {
			await changeActiveCourse(getParameterByName('course_id'));
		};
		document.getElementById('chat-circle').style.display = 'block';

		if (!!getParameterByName('course_id')) {
			setActiveCourse();
		} else {
			updateCourseDetails();
		}

	}, [updateCourseDetails, changeActiveCourse]);

	useEffect(() => {
		const setActiveCourse = async () => {
			await changeActiveCourse(paramCourseId);
		};
		document.getElementById('chat-circle').style.display = 'block';

		if (typeof paramCourseId !== 'null' && typeof paramCourseId !== 'undefined') {
			setActiveCourse();
		} else {
			updateCourseDetails();
		}
	}, [paramCourseId, updateCourseDetails, changeActiveCourse])

	useEffect(() => {
		if (getGrade) {
			setShowGrade(true);
		}
	}, [getGrade, setShowGrade]);

	const userDetailsObj = JSON.parse(localStorage.getItem('userDetails'));

	useEffect(() => {
		let isProfileUpdated =
			userDetailsObj !== null
				? userDetailsObj.user_phone !== null &&
				userDetailsObj.user_phone !== 'null' &&
				userDetailsObj.user_phone !== ''
				: false;
		let ignoreUpdateTime =
			localStorage.getItem('ignoreUpdateTime') !== null
				? moment(localStorage.getItem('ignoreUpdateTime'))
				: moment().subtract(1, 'day');
		let now = moment();
		if (
			isOlympiad &&
			!isProfileUpdated &&
			now.diff(ignoreUpdateTime, 'days') > 0
		) {
			setGetUserInfo(true);
		} else if (newUser && !isOlympiad) {
			appendScript('user_info');
		}
	}, [isOlympiad, newUser, setGetUserInfo, userDetailsObj]);

	let coachMsg = ""
	let coachTitle = "STEP COACH Calls and Tasks"
	let coachT1 = ""

	if (completed_calls == 0 && role_name == "" && course_id == "487") {
		coachTitle = "Welcome to Coach Unlimited!"
		coachT1 = "Hello, You are now a part of a <span>HIGHLY PERSONALISED</span> English course that will be <span>UNIQUELY DESIGNED</span> for your needs."
		coachMsg = "Please answer the following three questions to help us build out the right course for your needs. Happy Learning!"
	}

	if (isEmailUpdate) {
		window.location = "/profile?boa=1";
	}

	const setInitialActiveTabType = () => {
		return (addedGrants?.total <= 1)
			? addedGrants?.online
				? (addedGrants?.online !== false ? 'online' : '')
				: (addedGrants?.coach
					? 'coachcalls'
					: (addedGrants?.live_v2
						? 'liveclass'
						: 'online'))
			: '';
	}

	const [activeTabType, setActiveTabType] = useState(() => setInitialActiveTabType())

	useEffect(() => {
		setActiveTabType(setInitialActiveTabType())
	}, [addedGrants]);

	return (
		<>
			{(Object.keys(coursedetails).length === 0) ?
				<ShimmerEffect />
				:
				<>
					<div className="coursepage_course_name">{title}</div>
					{/* <div className={`mycourses-navi ${addedGrants?.total <= 1 ? 'hideElementImportant' : ''}`} > */}
					<div className={`mycourses-navi`} >
						<a className={`${activeTabType === 'online' ? 'active' : ''}`}
							// onClick={() => setActiveTabType('online')}
							onClick={() => { setActiveTabType('online') }}
						>
							<img src={Config.ASSETSPATH + 'img/mycourse-online-lessons.png'} alt="Online Lessons" />
							<span>Online <span>Lessons</span></span>
							<span class="tab-status-text"><span>Completed</span> {onlineClassStatus.completed}/{onlineClassStatus.total}</span>
							<span className={`buy-tag ${addedGrants?.online !== false ? 'hideElementImportant' : ''}`}>Buy</span>
						</a>
						<a
							// onClick={() => setActiveTabType('coachcalls')}
							onClick={() => { setActiveTabType('coachcalls') }}
							className={`${activeTabType === 'coachcalls' ? 'active' : ''}`}>
							<img src={Config.ASSETSPATH + 'img/mycourse-coach-calls.png'} alt="Coach Calls" />
							<span>Coach <span>Calls</span></span>
							<span class="tab-status-text"><span>Completed</span> {addedGrants?.coach === false ? '0/0' : coachCallsStatus}</span>
							<span className={`buy-tag ${addedGrants?.coach !== false ? 'hideElementImportant' : ''}`}>Buy</span>
						</a>
						<a
							onClick={() => { setActiveTabType('liveclass') }}
							className={`${activeTabType === 'liveclass' ? 'active' : ''}`}>
							<img src={Config.ASSETSPATH + 'img/mycourse-live-class.png'} alt="Live Classes" />
							<span>Live <span>Classes</span></span>
							<span class="tab-status-text"><span>Completed</span> {addedGrants?.live_v2 === false ? '0/0' : liveClassStatus.completed}/{liveClassStatus.total}</span>
							<span className={`buy-tag ${addedGrants?.live_v2 !== false ? 'hideElementImportant' : ''}`}>Buy</span>
						</a>
					</div>
					<ListAnimation className="courseContainer">
						<Notification />
						{previewMode ? (
							<Link to={`/purchase?productID=${product_id}`} className="changecourse">
								<i className="fa fa-undo"></i>
								<span>Back to product page</span>
							</Link>
						) : null}
						{/* {!coachMsg && addedGrants?.total <= 1 && <Status />} */}
						{!!coachMsg ? (
							<Card>
								<Card.Header>
									<h4 class="tiktik" dangerouslySetInnerHTML={{ __html: coachT1 }}></h4>
								</Card.Header>
							</Card>
						) : null}
						<Detail activeTabType={activeTabType} />
					</ListAnimation>

					<TestInstruction />
					{/* <EchoTest /> */}
					<ReviewAttemptModal />
					<GetGrade />
					<PermitMicModal />
				</>
			}
		</>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateCourseDetails: () => dispatch(updateCourseDetails()),
		changeActiveCourse: (id) => dispatch(changeActiveCourse(id)),
		fetchInstruction: (elementId, courseId, isReview = false) =>
			dispatch(fetchInstruction({ elementId, courseId, isReview })),
		setShowGrade: (val) => dispatch(setShowGrade(val)),
		setGetUserInfo: (val) => dispatch(setGetUserInfo(val)),
		setPreviewMode: (val) => dispatch(setPreviewMode(val)),
	};
};

const mapStateToProps = (state) => {
	const {
		elementId,
		title,
		getGrade,
		courseType,
		category,
		previewMode,
		coachDetails: { total_calls, completed_calls, show_feedback, feedback_url, role_name },
		coachDetails,
		course_id,
		isEmailUpdate,
		units,
		coursedetails: { live_classes, attempts_completed, totalnumberofattempts },
		addedGrants,
		coursedetails,
	} = state.rootReducer.myCourse;

	const onlineClassStatus = {
		completed: 0,
		total: 0
	}

	// Object.keys(units).forEach((item) => {
	// 	onlineClassStatus.total++;
	// 	if (units[item].completed_activites === units[item].total_activites) {
	// 		onlineClassStatus.completed++
	// 	}
	// })

	onlineClassStatus.total = totalnumberofattempts;
	onlineClassStatus.completed = attempts_completed;

	const coachCallsStatus = `${coachDetails.completed_calls}/${coachDetails.total_calls ? coachDetails.total_calls : 'Unlimited'}`

	const liveClassStatus = {
		completed: 0,
		total: live_classes?.length ? live_classes.length : 0
	}

	const todayDate = (new Date()).getDate()
	if (live_classes) {
		live_classes.forEach((item) => {
			if ((new Date(item.start_date)).getDate() < todayDate) {
				liveClassStatus.completed++
			}
		})
	}

	const {
		isOlympiad,
		newUser,
		isRetail,
		returnPath,
	} = state.rootReducer.loginDetails;
	const { productData: { product_id } = {} } = state.rootReducer.buyCourse;
	return {
		elementId,
		title,
		getGrade,
		isOlympiad,
		newUser,
		isRetail,
		courseType,
		returnPath,
		category,
		previewMode,
		product_id,
		coachDetails: { completed_calls, role_name },
		coachDetails,
		course_id,
		isEmailUpdate,
		onlineClassStatus,
		coachCallsStatus,
		liveClassStatus,
		addedGrants,
		coursedetails
	};
};

export default withRouter(
	compose(
		connect(mapStateToProps, mapDispatchToProps),
		DefaultLayoutHOC,
	)(MyCourse),
);
